import { AxiosError } from "axios"
import { notify } from "misc/notifications"

export const notifyApiError = (error: AxiosError) => {
  const responseData = error.response?.data as { detail?: string }

  if (responseData?.detail) {
    const errorText = responseData.detail
    console.error(errorText)
    notify(errorText, "error")
  }
}
